import {
  type DocumentData,
  type QueryConstraint,
  where,
} from "firebase/firestore";
import { firestoreApi } from "../../../core/apis/firestoreApi";
import BaseApi from "../../../core/BaseApi";
import {
  type BusinessTemplateData,
  BusinessTemplateModel,
} from "./BusinessTemplateModel";

export default class BusinessTemplatesApi extends BaseApi<
  BusinessTemplateModel,
  BusinessTemplateData
> {
  /* PRIVATE APIS */

  async getTemplatesForCustomer(customerUid: string) {
    const qs: QueryConstraint[] = [where("customerUid", "==", customerUid)];

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessTemplateModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });
    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_templates`;
  }

  get store() {
    return this.stores.businessTemplatesStore;
  }

  fromFirestore(res: DocumentData): BusinessTemplateModel {
    return new BusinessTemplateModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
